module.exports = __webpack_public_path__ + "static/media/sorting-icon.8c54628b.svg";